import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>

            <div style={{
                        backgroundImage: "linear-gradient(-25deg,rgb(232, 222, 244) 0%, rgb(255, 255, 255) 70%)",
                        paddingTop: "50px",
                        fontSize: "14px"
                    }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4">
                            <p style={{ fontSize: "17px" }}><strong>Strategic services</strong></p>
                            <p><Link to="/Technology-Consulting-Services">Technology consulting and services</Link></p>
                            <p><Link to="/services">Stragy consulting and design</Link></p>
                            <p><Link to="/workforce-strategy-and-plans">Workforce strategy and plans</Link></p>
                            {/* <p><Link to="/product-management">Product Management</Link></p> */}
                        </div>
                        <div className="col-md-4">
                            <p style={{ fontSize: "17px" }}><strong>Managed Services</strong></p>
                            <p><Link to="/Application-and-product-maintanence">Application & Product management</Link></p>
                            <p><Link to="/CloudOps">CloudOps</Link></p>
                        </div>
                    </div>

                </div>
                <footer className=" text-center py-3" >
                    {/* <div class="container">
                        <div class="row">
                            <div class="col-12 d-flex align-items-center">
                                <img src="assets/Logo White with Tagline.png" alt="companeny logo" class="footer-logo"/>
                                <p class="ml-5 mb-0">&copy; . All Rights Reserved.</p>
                            </div>
                        </div>
                    </div> */}
                    
                    <p><img src="assets/Logo White with Tagline.png" alt="companeny logo" class="footer-logo"/>&nbsp;&nbsp;&nbsp;     &copy; . All Rights Reserved.</p>
                </footer>
            </div>

        </>

    )
}

export default Footer;